var render = function render(){var _vm=this,_c=_vm._self._c;return _c('maintenance-page',{attrs:{"page-title":"User","page-icon":"mdi-account","collection-name":"user","done-redirect-url":"/auth/admin/user?isHistory=true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }